<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card v-if="item">
            <v-toolbar flat color="#008dd4" dark>
                <v-btn icon @click="$parent.show_dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ item.name }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-container>
                    <v-row justify="center" align="center">
                        <v-col lg="5" md="6" sm="12" xs="12">
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th>Clave</th>
                                            <th>Valor</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>ID</td>
                                            <td>{{ item.id }}</td>
                                        </tr>
                                        <tr>
                                            <td>Código</td>
                                            <td>{{ item.code }}</td>
                                        </tr>
                                        <tr>
                                            <td>Nombre</td>
                                            <td>{{ item.name }}</td>
                                        </tr>
                                        <tr>
                                            <td>Fecha de registro</td>
                                            <td>{{ item.registration_date }}</td>
                                        </tr>
                                        <tr>
                                            <td>Acuerdo por persona (Institución)</td>
                                            <td>${{ item.per_person }}</td>
                                        </tr>
                                        <tr>
                                            <td>Total de referidos permitidos</td>
                                            <td>{{ item.total_allowed }}</td>
                                        </tr>
                                        <tr>
                                            <td>Descuento</td>
                                            <td>${{ item.discount }}</td>
                                        </tr>
                                        <tr>
                                            <td>Tipo de comprobante</td>
                                            <td>{{ item.proof_type }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props:['item','dialog']
}
</script>